import {
  GET_MRD_FORM_FIELDS,
  GET_MRD_STATUSES_SUCCESS,
  GET_MRD_TYPES_SUCCESS,
  GET_POSTAL_OPERATORS_SUCCESS,
  EDIT_MRD_SUCCESS,
  EDIT_MRD_FAILURE,
  EDIT_MRD_REQUEST,
  GET_MRD_STATUSES_FAILURE,
  GET_MRD_TYPES_FAILURE,
  GET_POSTAL_OPERATORS_FAILURE,
  ADD_MRD_REQUEST,
  ADD_MRD_SUCCESS,
  ADD_MRD_FAILURE,
  ADD_MRD_STATUS,
  ASSOCIATE_HANDLER_STATUS,
  ASSOCIATE_HANDLER_REQUEST,
  ASSOCIATE_HANDLER_SUCCESS,
  ASSOCIATE_HANDLER_FAILURE,
  GET_ACTIVE_MRD_LIST_REQUEST,
  GET_ACTIVE_MRD_LIST_SUCCESS,
  GET_ACTIVE_MRD_LIST_FAILURE,
  FETCH_INBOUND_DATA_LOCATION_LIST_REQUEST,
  FETCH_INBOUND_DATA_LOCATION_LIST_SUCCESS,
  FETCH_INBOUND_DATA_LOCATION_LIST_FAILURE,
} from './types/DeviceInformationActionTypes';

export function getMrdFormFieldsRequestActionCreator(action) {
  return {
    type: GET_MRD_FORM_FIELDS,
    action,
  };
}

export function getMrdStatusesSuccessActionCreator(data) {
  return {
    type: GET_MRD_STATUSES_SUCCESS,
    payload: data,
  };
}

export function getMrdStatusesFailureActionCreator(error) {
  return {
    type: GET_MRD_STATUSES_FAILURE,
    payload: error,
    error: true,
  };
}

export function getMrdTypesSuccessActionCreator(data) {
  return {
    type: GET_MRD_TYPES_SUCCESS,
    payload: data,
  };
}

export function getMrdTypesFailureActionCreator(error) {
  return {
    type: GET_MRD_TYPES_FAILURE,
    payload: error,
    error: true,
  };
}

export function getPostalOperatorsSuccessActionCreator(data) {
  return {
    type: GET_POSTAL_OPERATORS_SUCCESS,
    payload: data,
  };
}

export function getPostalOperatorsFailureActionCreator(error) {
  return {
    type: GET_POSTAL_OPERATORS_FAILURE,
    payload: error,
    error: true,
  };
}

export function editMrdRequestActionCreator(action) {
  return {
    type: EDIT_MRD_REQUEST,
    payload: action,
  };
}

export function editMrdSuccessActionCreator(data) {
  return {
    type: EDIT_MRD_SUCCESS,
    payload: data,
  };
}

export function editMrdFailureActionCreator(error) {
  return {
    type: EDIT_MRD_FAILURE,
    payload: error,
    error: true,
  };
}

export function addMrdRequestActionCreator(action, persistFormData = {}) {
  return {
    type: ADD_MRD_REQUEST,
    payload: action,
    persistFormData,
  };
}

export function addMrdSuccessActionCreator(data) {
  return {
    type: ADD_MRD_SUCCESS,
    payload: data,
  };
}

export function addMrdFailureActionCreator(error) {
  return {
    type: ADD_MRD_FAILURE,
    payload: error,
    error: true,
  };
}

export function setAddMrdSuccessStatusActionCreator(status) {
  return {
    type: ADD_MRD_STATUS,
    status,
  };
}

export function setAssociateHandlerSuccessStatusActionCreator(status) {
  return {
    type: ASSOCIATE_HANDLER_STATUS,
    status,
  };
}

export function associateHandlerRequestActionCreator(mrdName, handlerList = []) {
  return {
    type: ASSOCIATE_HANDLER_REQUEST,
    payload: { mrdName, handlerList },
  };
}

export function associateHandlerSuccessActionCreator(data) {
  return {
    type: ASSOCIATE_HANDLER_SUCCESS,
    payload: data,
  };
}

export function associateHandlerFailureActionCreator(error) {
  return {
    type: ASSOCIATE_HANDLER_FAILURE,
    payload: error,
    error: true,
  };
}

export function getActiveMrdListRequestActionCreator(action) {
  return {
    type: GET_ACTIVE_MRD_LIST_REQUEST,
    payload: action,
  };
}

export function getActiveMrdListSuccessActionCreator(data) {
  return {
    type: GET_ACTIVE_MRD_LIST_SUCCESS,
    payload: data,
  };
}

export function getActiveMrdListFailureActionCreator(error) {
  return {
    type: GET_ACTIVE_MRD_LIST_FAILURE,
    payload: error,
    error: true,
  };
}

export function getInboundDataLocationsRequestActionCreator(payload) {
  return {
    type: FETCH_INBOUND_DATA_LOCATION_LIST_REQUEST,
    payload,
  };
}

export function getInboundDataLocationsSuccessActionCreator(payload) {
  return {
    type: FETCH_INBOUND_DATA_LOCATION_LIST_SUCCESS,
    payload,
  };
}

export function getInboundDataLocationsFailureActionCreator(payload) {
  return {
    type: FETCH_INBOUND_DATA_LOCATION_LIST_FAILURE,
    payload,
    error: true,
  };
}
